export const ModuleConst = {
  DASHBOARD: 1,
  CUSTOMERS: 2,
  MERCHANTS: 3,
  DEALSMANAGEMENT: 4,
  CATEGORIES: 5,
  BOOKINGS: 6,
  MEMBERSHIP: 7,
  PAYMENT: 8,
  REPORTANALYTICS: 9,
  REVIEWS: 10,
  SUBADMIN: 11,
  NOTIFICATIONS: 12,
  SETTINGS: 13,
  CMS: 14,
  LOGOUT: 15,
  SERVICEPROVIDER: 16,
  SUPPORT: 17,
  PRICE: 18,
  PACKAGE: 19,
  BANNER: 20,
  DEALS: 21,
  GUIDE: 22,
  HOMESTAY: 23,
  CHAT: 24,
  TICKETING: 25,
  COLLECTION: 26
};
